"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SetRequired = function () {
  function SetRequired() {
    _classCallCheck(this, SetRequired);
  }

  _createClass(SetRequired, null, [{
    key: "Set",
    value: function Set(textFields, selectFields, checkBoxes, postCodeCityStreet, emailRepeat) {
      if (textFields !== null && textFields !== undefined) {
        for (var i = 0; i < textFields.length; i++) {
          if (textFields[i].Key) {
            if (textFields[i].Key.props.IsRequired) {
              textFields[i].Key.setState({ Label: textFields[i].Key.props.Label + "*" });
            }
          } else {
            if (textFields[i].props.IsRequired) {
              textFields[i].setState({ Label: textFields[i].props.Label + "*" });
            }
          }
        }
      }

      if (selectFields !== null && selectFields !== undefined) {
        for (var _i = 0; _i < selectFields.length; _i++) {
          if (selectFields[_i].Key) {
            if (selectFields[_i].Key.props.IsRequired) {
              selectFields[_i].Key.setState({ Label: selectFields[_i].Key.props.Label + "*" });
            }
          } else {
            if (selectFields[_i].props.IsRequired) {
              selectFields[_i].setState({ Label: selectFields[_i].props.Label + "*" });
            }
          }
        }
      }

      if (checkBoxes !== undefined && checkBoxes !== null) {
        for (var _i2 = 0; _i2 < checkBoxes.length; _i2++) {
          if (checkBoxes[_i2].Key) {
            if (checkBoxes[_i2].Key.props.IsRequired) {
              if (checkBoxes[_i2].Key.props.Id !== "Captcha") {
                document.getElementById(checkBoxes[_i2].Key.props.Id).parentElement.parentElement.nextSibling.innerHTML += "*";
              }
            }
          } else {
            if (checkBoxes[_i2].props.IsRequired) {
              if (checkBoxes[_i2].props.Id !== "Captcha") {
                document.getElementById(checkBoxes[_i2].props.Id).parentElement.parentElement.nextSibling.innerHTML += "*";
              }
            }
          }
        }
      }

      if (postCodeCityStreet !== null && postCodeCityStreet !== undefined) {
        for (var _i3 = 0; _i3 < postCodeCityStreet.length; _i3++) {
          if (postCodeCityStreet[_i3].current) {
            if (postCodeCityStreet[_i3].current.props.IsRequired) {
              postCodeCityStreet[_i3].current.setState({ Label: postCodeCityStreet[_i3].current.props.Label + "*" });
            }
          }
        }
      }

      if (emailRepeat !== null && emailRepeat !== undefined) {
        for (var _i4 = 0; _i4 < emailRepeat.length; _i4++) {
          console.log(emailRepeat[_i4].current);
          if (emailRepeat[_i4].current) {
            if (emailRepeat[_i4].current.props.IsRequired) {
              emailRepeat[_i4].current.setState({ Label: emailRepeat[_i4].current.props.Label + "*" });
            }
          }
        }
      }
    }
  }]);

  return SetRequired;
}();

exports.default = SetRequired;